import { isUndefined } from 'lodash-es';
import { MattingType } from './types';

const MATTING_INFO_PRESET: Record<string, string> = {
    'https://x-design-release.stariicloud.com/seo/9abe0a3aab218a4b2fcd0b03338eb5a7.png':
        'https://x-design-release.stariicloud.com/poster/b9e386ad38d7fba785b7ecb5f546577c.png',
    'https://x-design-release.stariicloud.com/seo/133bc425a3df6bff702d724d465b3cee.png':
        'https://x-design-release.stariicloud.com/poster/fe33bc7fd83544fa5d94a0682d8becfb.png',
    'https://x-design-release.stariicloud.com/seo/31354262967d3c7e91ba08e84dd18218.png':
        'https://x-design-release.stariicloud.com/poster/5bf2dbd717b5e1ba77ca8dd2a526343e.png',
    'https://x-design-release.stariicloud.com/seo/c62c03f5a9ca19b913232acc00e74278.png':
        'https://x-design-release.stariicloud.com/poster/036317e3a2b6f8bc00f31b1a9bfe141d.png',
};

/**
 * 抠图预置精细蒙版
 * @param url
 * @param mattingType
 * @returns
 */
export const getMattingPreset = (url: string, mattingType?: MattingType) => {
    console.log('getMattingPreset', url, MATTING_INFO_PRESET[url]);
    // 仅在默认抠图模式下使用预设蒙版
    if (!isUndefined(mattingType)) {
        return '';
    }
    return MATTING_INFO_PRESET[url] || '';
};
